// extracted by mini-css-extract-plugin
export default {"title":"Teacher_title__8hNoe"};